import { useRouter, useRoute } from 'vue-router';

export default function useRouteController(routeName) {
  const router = useRouter();
  const route = useRoute();


  const setRouteQuery = function (query) {



    router.push({
      name: routeName,
      query: {
        ...route.query,
        ...query,
      },
    });
  };

  const setRouteTypeValue = function ({ type, value }) {

    setRouteQuery({ [type]: value });
  };

  const getRouterQueryValue = function (queryName) {

    const value = Object.prototype.hasOwnProperty.call(route.query, queryName)
      ? route.query[queryName]
      : null;

    return value;
  };

  return {
    setRouteQuery,
    setRouteTypeValue,
    getRouterQueryValue,
  };
}
